import LabelText from '../ui/LabelText';

const highlightText = (text: string, searchText: string) => {
    const parts = text.split(new RegExp(`(${searchText!})`, 'gi'));
    return (
        <LabelText className='custom-list-text'>
            {parts.map((part, index) => {
                if (part.toLowerCase() === searchText?.toLowerCase()) {
                    return <LabelText key={index} className='custom-list-strong-text'>{part}</LabelText>;
                } else {
                    return <LabelText className='custom-list-text' key={index}>{part}</LabelText>;
                }
            })}
        </LabelText>
    );
};

export default highlightText;
